export const AGENTIC_WORKERS_MESSAGE = {
	BUTTON_WORKING: 'agentic_workers.button.working',
	BUTTON_STOP: 'agentic_workers.button.stop',
	BUTTON_WORKING_NAME: 'agentic_workers.button.working_name',
	MENU_RUN: 'agentic_workers.menu.run',
	MENU_RUNNING: 'agentic_workers.menu.running',
	MENU_SCHEDULE: 'agentic_workers.menu.schedule',
	MENU_PAST_RUNS: 'agentic_workers.menu.past_runs',
	BADGE_WAITING: 'agentic_workers.badge.waiting',
	TOAST_RUN_STOPPED: 'agentic_workers.toast.run_stopped',
	TOAST_RESULT_DELETED: 'agentic_workers.toast.result_deleted',
	TOAST_RESULT_HIDDEN: 'agentic_workers.toast.result_hidden',
	TOAST_ALREADY_DELETED: 'agentic_workers.toast.already_deleted',
	TOAST_ALREADY_ACTED: 'agentic_workers.toast.already_acted',
	TOAST_SOMEONE: 'agentic_workers.toast.someone',
	ROW_ACTION_WORKING: 'agentic_workers.row_action.working',
	ROW_ACTION_READY: 'agentic_workers.row_action.ready',
	ROW_ACTION_STOP: 'agentic_workers.row_action.stop',
	ROW_ACTION_STOP_PAGE_RUN: 'agentic_workers.row_action.stop_page_run',
	ROW_ACTION_READY_MENU: 'agentic_workers.row_action.ready_menu',
	PANEL_LABEL: 'agentic_workers.panel.label',
	PANEL_REVIEW: 'agentic_workers.panel.review',
	PANEL_DELETE: 'agentic_workers.panel.delete',
	PANEL_HIDE: 'agentic_workers.panel.hide',
	PANEL_TITLE: 'agentic_workers.panel.title',
	PANEL_DATE_LINE: 'agentic_workers.panel.date_line',
	PANEL_RUN_JUST_NOW: 'agentic_workers.panel.run_just_now',
	PANEL_RUN_AT: 'agentic_workers.panel.run_at',
	FAILED_TITLE: 'agentic_workers.failed.title',
	FAILED_RETRY: 'agentic_workers.failed.retry',
	FAILED_REASON_TIMED_OUT: 'agentic_workers.failed.reason_timed_out',
	FAILED_REASON_UNKNOWN: 'agentic_workers.failed.reason_unknown',
} as const;
